export default __webpack_public_path__ + "f6b2bfac3fbd69a28f3fef4136faffec.png";